import ENV from '@/env'

class FetchService {
  static getHeaders (headers) {
    const defaults = {'Content-Type': 'application/json', 'Accept': 'application/json'}
    return new window.Headers(Object.assign(defaults, headers))
  }

  static async fetch (url, args = {}) {
    if (!url) throw new Error('no url')
    args = Object.assign({headers: {}, method: 'GET'}, args)
    let opts = {
      method: args.method.toUpperCase(),
      headers: this.getHeaders(args.headers)
    }
    if (args.data) {
      opts.body = JSON.stringify(args.data)
    }

    let apiBase = ENV.API_URL
    if (args.permitCheck) {
      apiBase = ENV.WP_API + '/permit-check'
    }

    let response = await window.fetch(`${apiBase}${url}`, opts)
    if (response.status === 204) return true
    const body = await response.json()
    body._success = [200, 201, 202, 203].indexOf(response.status) >= 0
    return body
  }

  static post (url, args = {}) {
    return this.fetch(url, Object.assign({method: 'POST'}, args))
  }

  static get (url, args = {}) {
    return this.fetch(url, Object.assign({method: 'GET'}, args))
  }

  static async getFeeTable (endpoint) {
    const response = await window.fetch(`${ENV.WP_API}${endpoint}`)
    if (response.status === 204) return true
    const body = await response.json()
    body._success = [200, 201, 202, 203].indexOf(response.status) >= 0
    return body
  }
}

export default FetchService



// WEBPACK FOOTER //
// ./src/api.js